<public-account-shell [heading]="'account.verify.title' | transloco">
  @switch (state()) {
    @case ('verifying') {
      <p class="verify__status" role="status">{{ 'account.verify.verifying' | transloco }}</p>
    }
    @case ('success') {
      <div class="verify__result" role="status">
        <i class="fa-solid fa-circle-check verify__icon verify__icon--success" aria-hidden="true"></i>
        <p class="verify__text">{{ 'account.verify.success' | transloco }}</p>
        <button eBtn block color="primary" type="button" routerLink="/login">
          {{ 'account.verify.toLogin' | transloco }}
        </button>
      </div>
    }
    @default {
      <div class="verify__result" role="alert">
        <i class="fa-solid fa-circle-exclamation verify__icon verify__icon--error" aria-hidden="true"></i>
        <p class="verify__text">
          {{ (state() === 'missingToken' ? 'account.verify.missingToken' : 'account.verify.failed') | transloco }}
        </p>

        @if (resendCompleted()) {
          <p class="verify__resent" role="status">{{ 'account.verify.resent' | transloco }}</p>
        } @else {
          <form class="verify__resend" (ngSubmit)="onResendVerification()">
            <label class="verify__label" for="resendEmail">{{ 'account.verify.resendLabel' | transloco }}</label>
            <input
              id="resendEmail"
              name="resendEmail"
              type="email"
              class="verify__input"
              [ngModel]="resendEmail()"
              (ngModelChange)="resendEmail.set($event)"
              autocomplete="email"
              required
            />
            <button eBtn block color="primary" type="submit" [loading]="isResending()">
              {{ 'account.verify.resend' | transloco }}
            </button>
          </form>
        }
        <a routerLink="/login" class="verify__link">{{ 'account.verify.backToLogin' | transloco }}</a>
      </div>
    }
  }
</public-account-shell>
